import { Fade, LMask } from "./Reveal";
import { ARROW_UR } from "./Bits";
import { EMAIL, GITHUB_URL, LINKEDIN_URL, RESUME_URL } from "../data";

export function Contact() {
  return (
    <section id="contact" className="contact">
      <Fade className="small">Want to chat?</Fade>
      <h2>
        <LMask>GET IN</LMask>
        <LMask>TOUCH</LMask>
      </h2>
      <Fade as="p">
        I'm currently looking for software internships. If you have an opportunity, a
        project idea, or just want to say hi, reach out.
      </Fade>
      <Fade as="a" className="mail" href={`mailto:${EMAIL}`}>
        {EMAIL}
      </Fade>
      <Fade className="contact-cta">
        <a className="ed-btn solid" href={RESUME_URL} target="_blank" rel="noreferrer">
          View Résumé <span className="a">{ARROW_UR}</span>
        </a>
        <a className="ed-btn" href={GITHUB_URL} target="_blank" rel="noreferrer">
          GitHub <span className="a">{ARROW_UR}</span>
        </a>
        <a className="ed-btn" href={LINKEDIN_URL} target="_blank" rel="noreferrer">
          LinkedIn <span className="a">{ARROW_UR}</span>
        </a>
      </Fade>
    </section>
  );
}
